<template>
    <div>
        <h1>Contact Me</h1>
        <p>Discord: {{discord}}</p>
        <p>Reddit: <a :href="'https://www.reddit.com/message/compose/?to=' + reddit" >click here</a></p>
    </div>
</template>

<script>
    export default {
        name: 'Contact',
        data(){
            return {
                discord: "CoUsT#8894",
                reddit: "CoUsT"
            }
        }
    }
</script>